var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-view"},[_c('div',{staticClass:"login-view-container"},[_c('div',{staticClass:"h-100 row align-items-center"},[_c('login',{staticClass:"col-sm-12 col-md-4"})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }